/**
 * Renders a radio choice for a question.
 */
import React, { PropTypes } from 'react';

function QuestionOption({
  currentAnswer,
  currentQuestion,
  index,
  label,
  recordChoice,
}) {
  return (
    <span>
      <input
        defaultChecked={currentAnswer === index}
        id={`question-${currentQuestion.id}-${index}`}
        name={`question-${currentQuestion.id}`}
        onClick={() => recordChoice(currentQuestion.id, index)}
        type="radio"
        value={index}
      />
      <br />
      <label htmlFor={`question-${currentQuestion.id}-${index}`}>
        {label}
      </label>
    </span>
  );
}

QuestionOption.propTypes = {
  currentAnswer: PropTypes.number,
  currentQuestion: PropTypes.shape({}),
  index: PropTypes.number,
  label: PropTypes.string,
  recordChoice: PropTypes.func,
};

export default QuestionOption;



// WEBPACK FOOTER //
// js/src/assessment/QuestionChoice.js